import { PLATFORM_TYPE_KEY } from "@/constants/localStorageKeys";
import { ANDROID, IOS } from "@/constants/platformTypes";

export default {
  isIos() {
    return localStorage.getItem(PLATFORM_TYPE_KEY) === IOS;
  },
  isAndroid() {
    return localStorage.getItem(PLATFORM_TYPE_KEY) === ANDROID;
  }
}

